import type { CityConfig } from "../city-template/types";

export const marshalltownConfig: CityConfig = {
  city: "Marshalltown",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "marshalltown",
  route: "/cities/marshalltown",
  title: "Emergency Passport Marshalltown, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Marshalltown, IA — as fast as 24 hours. Serving Marshall County and Central Iowa. A+ BBB rated registered State Dept. courier serving Lennox International and JBS Swift professionals, Iowa Veterans Home staff, and Central Iowa manufacturing workers. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Marshalltown, IA",
  heroSubtitle: "Lennox International conference in Mexico with 5 days notice and your passport expired? JBS Swift corporate trip to Brazil and no documents ready? Iowa Veterans Home staff heading to an international conference? We help Marshalltown and Central Iowa residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Marshalltown%20Iowa%20historic%20downtown%20with%20Marshall%20County%20Courthouse%20clock%20tower%20brick%20Main%20Street%20buildings%20and%20Iowa%20River%20backdrop%20Central%20Iowa%20manufacturing%20city%20at%20golden%20hour%20warm%20sunlight%20industrial%20heritage&width=1800&height=700&seq=marshalltown-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Marshalltown Iowa historic downtown and Marshall County Courthouse Central Iowa at golden hour",
  geoPosition: "42.0494;-92.9080",
  geoPlacename: "Marshalltown, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 310 miles east of Marshalltown via US-30 and I-80",
  },
  nearbyCitiesZips: [
    { name: "Marshalltown", zips: "50158" },
    { name: "Tama", zips: "52339" },
    { name: "Toledo", zips: "52342" },
    { name: "State Center", zips: "50247" },
    { name: "Conrad", zips: "50621" },
    { name: "Grundy Center", zips: "50638" },
    { name: "Eldora", zips: "50627" },
    { name: "Grinnell", zips: "50112" },
    { name: "Newton", zips: "50208" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Pella", zips: "50219" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Waterloo", zips: "50701–50707" },
    { name: "Boone", zips: "50036" },
    { name: "Fort Dodge", zips: "50501" },
    { name: "Cedar Falls", zips: "50613" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Central Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Central Iowa Coverage", desc: "Serving Marshall, Tama, Grundy, and surrounding counties" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Fast passport renewal in Ames, IA", route: "/cities/ames" },
    { name: "Emergency passport help in Grinnell, IA", route: "/cities/grinnell" },
    { name: "Urgent passport services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
    { name: "Same-day passport help in Waterloo, IA", route: "/cities/waterloo-ia" },
    { name: "Passport courier services in Pella, IA", route: "/cities/pella" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Marshalltown remotely via secure courier. We do not have a walk-in office in Marshalltown — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Marshall County and the entire Central Iowa region.",
  fpcOfficeAddress: "801 Grand Ave, Des Moines, Iowa 50309",
  fpcOfficeDistance: "Serving all of Marshall County and the Central Iowa region including Tama, Grundy, Hardin, and surrounding counties",
  serviceAreaIntro: "From the Lennox International manufacturing campus with its global supply chain to JBS Swift's major pork processing facility, from the Iowa Veterans Home serving veterans statewide to the historic Marshall County Courthouse with its iconic clock tower, from the Orpheum Theater on Main Street to the Iowa River and Linn Creek recreational areas — Fast Passport Center serves the entire Marshalltown region. We regularly help travelers from Marshalltown, Tama, Toledo, and Grundy Center get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Marshalltown neighborhoods and the surrounding Central Iowa area including Tama, Toledo, State Center, Conrad, Grundy Center, Eldora, and Grinnell. If you are anywhere in Marshall County, Tama County, or Central Iowa, we have you covered.",
  howItWorksIntro: "Most Marshalltown travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Central Iowa travelers often face a 5-plus-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Marshalltown and Marshall County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Marshalltown? Here are the most common ones we hear from Central Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Marshalltown travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Marshall County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Carlos M.",
      location: "Marshalltown, IA",
      rating: 5,
      text: "Lennox International sent me to our Mexico plant with 6 days notice. Fast Passport Center renewed my passport in 2 days. My plant manager was stunned. Now Lennox HR has their number posted in the break room for international travel.",
      service: "Passport Renewal",
    },
    {
      name: "Ron T.",
      location: "Marshalltown, IA",
      rating: 5,
      text: "JBS corporate trip to Brazil — 5 days notice and my passport expired. Fast Passport Center got it in 3 days. Made it to the São Paulo office right on schedule. My colleagues in Greeley asked how I did it so fast.",
      service: "Emergency Passport",
    },
    {
      name: "Deb and Paul R.",
      location: "Tama, IA",
      rating: 5,
      text: "Retirement cruise from Barcelona — booked a year ago but forgot to check our passports. Both expired! Fast Passport Center renewed both in 4 days. We made it to the ship with 2 days to spare. First round of sangria was on us!",
      service: "Passport Renewal",
    },

  ],
  facilities: [
    {
      id: "marshalltown-1",
      name: "Marshalltown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 S 3rd Ave",
      city: "Marshalltown",
      state: "IA",
      zip: "50158",
      phone: "(641) 752-4261",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Marshalltown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Marshalltown facility. Serves Marshall County. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "marshalltown-2",
      name: "Marshall County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "1 E Main St",
      city: "Marshalltown",
      state: "IA",
      zip: "50158",
      phone: "(641) 754-6323",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Marshall County Courthouse",
      website: "https://www.marshallcountyia.gov/recorder",
      websiteLabel: "Marshall County Recorder",
      notes: "Accepts passport applications at the courthouse. Extended weekday hours. Good alternative.",
      icon: "ri-government-line",
    },
    {
      id: "marshalltown-3",
      name: "Tama Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "319 W 3rd St",
      city: "Tama",
      state: "IA",
      zip: "52339",
      phone: "(641) 484-2911",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles east of Marshalltown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Tama and Tama County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "marshalltown-4",
      name: "Grinnell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "921 4th Ave",
      city: "Grinnell",
      state: "IA",
      zip: "50112",
      phone: "(641) 236-7531",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southeast of Marshalltown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Poweshiek County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "marshalltown-5",
      name: "Grundy Center Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "703 G Ave",
      city: "Grundy Center",
      state: "IA",
      zip: "50638",
      phone: "(319) 824-3611",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles north of Marshalltown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Grundy County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "marshalltown-6",
      name: "Eldora Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1310 12th St",
      city: "Eldora",
      state: "IA",
      zip: "50627",
      phone: "(641) 939-7411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles northwest of Marshalltown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hardin County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Small-town photo shops in Central Iowa often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Marshall County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Marshalltown applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Marshalltown Community School District families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Marshalltown manufacturing workers often assume passports aren't needed for domestic travel. Start expedited at least 3 weeks before any international trip.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Marshalltown." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Marshalltown address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Marshalltown before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Marshalltown for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-plus-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Marshalltown?", a: "Fast Passport Center offers fast passport renewal in Marshalltown in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Marshalltown?", a: "The nearest regional passport agency to Marshalltown is the Chicago Passport Agency, approximately 310 miles east via US-30 and I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Marshalltown without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Marshalltown?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5-plus hours from Marshalltown — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Marshall County and Central Iowa residents." },
    { q: "Do you serve the manufacturing community in Marshalltown?", a: "Absolutely. Fast Passport Center regularly serves Lennox International, JBS Swift, and other Marshalltown manufacturing professionals needing fast passports for international business travel. Our courier service handles everything online — no need to take time off work for a trip to Chicago." },
    { q: "Can I expedite a child passport in Marshalltown?", a: "Yes. Fast Passport Center expedites child passports in Marshalltown for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Marshalltown families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Marshalltown with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Marshalltown", address: "2802 S Center St, Marshalltown, IA 50158", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Marshalltown", address: "507 N 3rd Ave, Marshalltown, IA 50158", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Grinnell", address: "1310 W St S, Grinnell, IA 50112", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walmart Supercenter — Ames", address: "534 S Duff Ave, Ames, IA 50010", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Ames", address: "2717 Grand Ave, Ames, IA 50010", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — West Des Moines", address: "6305 Mills Civic Pkwy, West Des Moines, IA 50266", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Marshalltown Driver's License",
      address: "3408 S Center St, Marshalltown, IA 50158",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Marshall County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Grinnell Driver's License",
      address: "220 4th Ave W, Grinnell, IA 50112",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Poweshiek County. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Ames Driver's License",
      address: "1900 S Dayton Ave, Ames, IA 50010",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Story County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "55 miles southwest of Marshalltown",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 1 hour from Marshalltown.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "85 miles east of Marshalltown",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa. About 1 hour 20 minutes from Marshalltown.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "ALO",
      name: "Waterloo Regional Airport",
      distance: "50 miles northeast of Marshalltown",
      address: "2790 Airport Blvd, Waterloo, IA 50703",
      note: "Regional airport with daily flights. About 50 minutes from Marshalltown.",
      flightUrl: "https://www.flyalo.com/",
      flightLabel: "ALO Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Iowa Department of Public Health Vital Records. Online, mail, or in-person options for Marshall County residents.", url: "https://hhs.iowa.gov/vital-records" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through IDPH Vital Records. Required for estate, insurance, and legal matters.", url: "https://hhs.iowa.gov/vital-records" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Marshall County Recorder. Certified copies available for name changes.", url: "https://www.marshallcountyia.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Marshall County Clerk of Court. Required for name change passport corrections.", url: "https://www.iowacourts.gov/" },
  ],
};